/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = [
            'ROLE_USER',
            'ROLE_ADMIN',
            'ROLE_BOARD',
            'ROLE_FINANCE',
            'ROLE_MANAGER',
            'ROLE_DINGHY',
            'ROLE_SKIPPER',
            'ROLE_SKIPPER_CANDIDATE',
            'ROLE_SKIPPER_ASKEW',
            'ROLE_SKIPPER_MANAGER',
            'ROLE_INSTRUCTOR',
            'ROLE_SKS_PLUS',
            'ROLE_SAILOR_COUNCIL',
            'ROLE_BOAT',
            'ROLE_CLOUD',
            'ROLE_UNIVERSITY_GROUP',
            'ROLE_IT'
        ];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                //User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();
